<template>
<div class="">

    <!-- Modal red de Conceptos -->
    <b-modal hide-footer header-text-variant="true" id="modal-redConceptos" size="xl">
        <div>
            <img src="recursos/img/red.png" class="img-fluid mx-auto d-none d-lg-block d-md-none" alt="">
            <img src="recursos/img/red_cel.png" class="img-fluid mx-auto d-block d-lg-none" alt="">
        </div>
    </b-modal>
    <!-- Modal red de Conceptos -->

    <!-- Modal Tema1 Slide 1 -->
    <b-modal hide-footer header-text-variant="true" id="modal-Tema1Slide1" size="xl">
        <div>
            <p class="txtfiguras">Tabla 1<br> <span class="font-italic">Piaget y las etapas del desarrollo cognitivo: ideas clave</span> </p>
            <div class="d-block d-xl-none d-lg-block d-md-none">
                <h6 class="mt-4 mb-4 text-center enunciadoFormula"> Para ver la tabla completa, dé clic sostenido sobre ella y desplácela.</h6>
            </div>
            <div class="tabla1 mt-3 table-responsive">
                <table class="table table-bordered">
                    <tbody>
                        <tr class="EncabezadoTabla">
                            <td class="align-middle pb-0 mb-0 bordeiztabla">
                                <h5 class="text-center">Etapa </h5>
                            </td>
                            <td class="align-middle pb-0 mb-0">
                                <h5 class="text-center">Edad aproximada </h5>
                            </td>
                            <td class="align-middle pb-0 mb-0 bordedertabla">
                                <h5 class="text-center">Características </h5>
                            </td>
                        </tr>
                        <tr>
                            <td class="align-middle pb-0 mb-0">
                                <p class="text-center">Sensoriomotora</p>
                            </td>
                            <td class="align-middle pb-0 mb-0">
                                <p class="text-center">0-2 años</p>
                            </td>
                            <td class="align-middle pb-0 mb-0">
                                <ul>
                                    <li>
                                        <p class="mb-0 pb-0">Empieza a hacer uso de la imitación, la memoria y el pensamiento.</p>
                                    </li>
                                    <li>
                                        <p class="mb-0 pb-0">Empieza a reconocer que los objetos no dejan de existir cuando son ocultados.</p>
                                    </li>
                                    <li>
                                        <p class="mb-0 pb-0">Pasa de las acciones reflejas a la actividad dirigida a metas.</p>
                                    </li>
                                </ul>
                            </td>
                        </tr>
                        <tr>
                            <td class="align-middle pb-0 mb-0">
                                <p class="text-center">Preoperacional </p>
                            </td>
                            <td class="align-middle pb-0 mb-0">
                                <p class="text-center">2-7 años </p>
                            </td>
                            <td class="align-middle pb-0 mb-0">
                                <ul>
                                    <li>
                                        <p class="mb-0 pb-0">Desarrolla gradualmente el uso del lenguaje y la capacidad para pensar en forma simbólica.</p>
                                    </li>
                                    <li>
                                        <p class="mb-0 pb-0">Es capaz de pensar lógicamente en operaciones unidireccionales.</p>
                                    </li>
                                    <li>
                                        <p class="mb-0 pb-0">Le resulta difícil considerar el punto de vista de otra persona.</p>
                                    </li>
                                </ul>
                            </td>
                        </tr>
                        <tr>
                            <td class="align-middle pb-0 mb-0">
                                <p class="text-center">Operaciones concretas </p>
                            </td>
                            <td class="align-middle pb-0 mb-0">
                                <p class="text-center">7-11 años </p>
                            </td>
                            <td class="align-middle pb-0 mb-0">
                                <ul>
                                    <li>
                                        <p class="mb-0 pb-0">Es capaz de resolver problemas concretos de manera lógica (activa).</p>
                                    </li>
                                    <li>
                                        <p class="mb-0 pb-0">Entiende las leyes de consevación y es capaz de clasificar y establecer series</p>
                                    </li>
                                    <li>
                                        <p class="mb-0 pb-0">Entiende la reversibilidad.</p>
                                    </li>
                                </ul>
                            </td>
                        </tr>
                        <tr>
                            <td class="align-middle pb-0 mb-0">
                                <p class="text-center">Operaciones formales </p>
                            </td>
                            <td class="align-middle pb-0 mb-0">
                                <p class="text-center">11-adultez </p>
                            </td>
                            <td class="align-middle pb-0 mb-0">
                                <ul>
                                    <li>
                                        <p class="mb-0 pb-0">Es capaz de resolver problemas abstractos de manera lógica.</p>
                                    </li>
                                    <li>
                                        <p class="mb-0 pb-0">Su pensamiento se hace más científico.</p>
                                    </li>
                                    <li>
                                        <p class="mb-0 pb-0">Desarrolla interés por los temas sociales, identidad.</p>
                                    </li>
                                </ul>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <p class="txtfiguras">Fuente: Guerrero, J. (2019). Recuperada de <span class="url"><a href="https://docentesaldia.com/2019/01/23/piaget-y-las-etapas-del-desarrollo-cognitivo-ideas-clave/" target="_blank">https://docentesaldia.com</a></span></p>
        </div>
    </b-modal>
    <!-- Modal Tema1 Slide 1 -->

    <!-- Modales Actividad de Autoevaluación  -->
    <b-modal hide-footer header-text-variant="true" id="modal-Autoevaluacion01" size="xl">
        <div>
            <p class="">

                *Para la presente actividad se toma una definición de la siguiente referencia:

                Universidad Pedagógica Nacional-hidalgo. (2013). <i>Los procesos evolutivos</i> del desarrollo integral en la primera infancia. México: UPN Morelos. Recuperado de <a href="https://upnmorelos.edu.mx/assets/procesos-evolutivos.pdf" target="_blank" rel="noopener noreferrer">https://upnmorelos.edu.mx/assets/procesos-evolutivos.pdf</a>

            </p>
        </div>
    </b-modal>

    <b-modal hide-footer header-text-variant="true" id="modal-resultado-Autoevaluacion" size="xl">
        <div class="row d-flex align-items-center">
            <div class="col-lg-4 col-md-12">
                <img :src="imgURL" class="img-fluid mx-auto d-none d-lg-block d-md-none" alt="" id="imgResultadoAUTOEV">
            </div>
            <div class="col-lg-8 col-md-12 mt-lg-0 mt-3">
                <h3 class="color1 mt-3" id="tituloResultado">{{tituloResultado}}</h3>
                <p class="mt-3" id="descripcionResultado">{{descripcionResultado}}</p>
            </div>
        </div>
    </b-modal>
    <!-- Modales Actividad de Autoevaluación  -->

</div>
</template>

<script>
export default {
    name: 'Modales',
    props: {
        tituloResultado: {
            type: String,
            required: true
        },
        descripcionResultado: {
            type: String,
            required: true
        },
        imgURL: {
            type: String,
            required: true
        }
    }
}
</script>
